import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/login/login';
import PageNotFound from './components/pageNotFound/pageNotFound';
import Home from './components/Home/home';
import { ToastContainer } from 'react-toastify';
import MainView from './mainview';
import NetworkStatus from "./networkStatus";
import ErrorComponent from './components/errorComponent/ErrorComponent';
import Gamelist from './components/Games/GamesList/gamesList'
import GameDetailView from './components/Games/GamesList/gameDetailView'
import OfflineGames from './components/Games/OfflineGames/offlineGames'
import Subject from './components/Games/Subject/subject'
import TvApks from './components/Masters/TvApksPage/tvapkPage';
import TvApkProjects from './components/Masters/ProjectsPage/tvapkProject';
import TvApkManage from './components/Masters/TvApksPage/manage/index';
import Categories from './components/Games/Categories/categories';
import MarketingBanners from './components/Games/MarketingBanners/marketingBanners';
import GameReviews from './components/Games/GameReviews/gameReviews';
import CreateQuiz from './components/Games/CreateQuiz/CreateQuiz';
import SystemUsers from './components/UsersAndSubscribers/SystemUsers/systemUsers';
import UsersList from './components/UsersAndSubscribers/Userslist/usersList';
import OfflineUsersList from './components/UsersAndSubscribers/OfflineUsers/offlineUsersList';
import Database from './components/Developer/Database/database';
import Logs from './components/Developer/Log/logs';
import S3Component from './components/Developer/s3/S3Component';
import SystemSettings from './components/Settings/SystemSettings/systemSettings';
import OnlineContent from './components/Settings/OnlineContent/onlineContent';
import Roles from './components/Settings/Roles/roles';
import Assets from './components/Masters/assets';
import Games from './components/Game/Games';
import GamesView from './components/Game/GamesView';
import AccessControl from './components/Settings/AccessControl/accessControl';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    element: <MainView />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/home",
        element: <Home />,
      },
      {
        path: "/games/gamelist",
        element: <Gamelist />,
      },
      {
        path: "/games/gameDetailView/:game_id",
        element: <GameDetailView />,
      }, {
        path: "/games/offlineGames",
        element: <OfflineGames />,
      },
      {
        path: "/games/Categories",
        element: <Categories />,
      },
      {
        path: "/games/subject",
        element: <Subject />,
      },
      {
        path: "/games/marketingBanners",
        element: <MarketingBanners />,
      },
      {
        path: "/games/createQuiz",
        element: <CreateQuiz />,
      },
      {
        path: "/games/gameReviews",
        element: <GameReviews />,
      },
      {
        path: "/userAndSubscribers/usersList",
        element: <UsersList />,
      },
      {
        path: "/userAndSubscribers/offlineUsersList",
        element: <OfflineUsersList />,
      },
      {
        path: "/userAndSubscribers/project/:projectId",
        element: <OfflineUsersList />,
      },
      {
        path: "/userAndSubscribers/systemUsers",
        element: <SystemUsers />,
      },
      {
        path: "/developer/database",
        element: <Database />,
      },
      {
        path: "/developer/logs",
        element: <Logs />,
      },
      {
        path: "/developer/s3",
        element: <S3Component />,
      },
      {
        path: "/settings/systemSettings",
        element: <SystemSettings />,
      },
      {
        path: "/settings/online-content",
        element: <OnlineContent />,
      },
      {
        path: "/settings/accessControl",
        element: <AccessControl />,
      },
      {
        path: "/settings/roles",
        element: <Roles />,
      },
      {
        path: "/masters/assets",
        element: <Assets />,
      },
      {
        path: "/masters/games",
        element: <Games />,
      }, {
        path: "/projects/:projectId/tvapks",
        element: <TvApks />
      }, {
        path: "/masters/tvApkProjects",
        element: <TvApkProjects />,
      },
      {
        path: "/tvapk/manage/:projectId/:id",
        element: <TvApkManage />,
      },
      {
        path: "/masters/games/view/:gameid",
        element: <GamesView />,
      },


    ],
    errorElement: <ErrorComponent />,
  },
]);

function App() {
  return (
    <div className="App">
      <NetworkStatus />
      <RouterProvider router={router} />
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default App;
